import { defineMessages } from "react-intl"

export const QUICKBOOKS_FORM_COMPONENT_MESSAGES = defineMessages({
    inventoryTooltipMsg: {
        id: "integration.form.quickbooks_form_component.inventory_tooltip_msg",
        defaultMessage: "Inventory module must be disabled first to enable this function"
    }
})


// WEBPACK FOOTER //
// ./src/utils/integration/quickbooks/messages.ts